"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHelperErrorText = exports.StyledHeader = exports.StyledLabelBox = exports.StyledLabel = exports.StyledRightValue = exports.StyledLeftValue = exports.StyledValueBox = exports.StyledIconBox = exports.StyledRangePriceBox = exports.StyledWrapper = exports.StyledInput = void 0;
const input_1 = require("@pulse-web-ui/input");
const theme_1 = require("@pulse-web-ui/theme");
const range_input_types_1 = require("./range-input.types");
exports.StyledInput = (0, theme_1.styled)(input_1.Input) `
  user-select: none;
  ${({ readOnly, error, theme }) => {
    var _a;
    return readOnly &&
        (0, theme_1.css) `
      cursor: default;
      ${!((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined) &&
            !error &&
            (0, theme_1.css) `
        &:hover,
        &:focus {
          background: ${({ theme }) => theme.colors.neutral[10]};
        }
      `}
    `;
}}

  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.neutral[30]};
  }
`;
exports.StyledWrapper = theme_1.styled.div `
  position: relative;

  ${({ label }) => label &&
    (0, theme_1.css) `
      margin-top: 12px;
    `}
`;
exports.StyledRangePriceBox = theme_1.styled.div `
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
exports.StyledIconBox = theme_1.styled.span `
  position: absolute;
  top: 14px;
  bottom: 14px;

  ${({ iconPosition }) => iconPosition === range_input_types_1.IconPosition.LEFT &&
    (0, theme_1.css) `
      left: 16px;
    `}

  ${({ iconPosition }) => iconPosition === range_input_types_1.IconPosition.RIGHT &&
    (0, theme_1.css) `
      right: 16px;
    `}
`;
exports.StyledValueBox = theme_1.styled.div `
  display: flex;
  justify-content: space-between;
`;
exports.StyledLeftValue = theme_1.styled.span `
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-left: 11px;
  ${theme_1.typography.regular14}
  line-height: 20px;

  ${({ isError }) => isError &&
    (0, theme_1.css) `
      color: ${({ theme }) => theme.colors.text.error};
    `}
`;
exports.StyledRightValue = theme_1.styled.span `
  color: ${({ theme }) => theme.colors.text.secondary};

  margin-right: 9px;
  ${theme_1.typography.regular14}
  line-height: 20px;

  ${({ isError }) => isError &&
    (0, theme_1.css) `
      color: ${({ theme }) => theme.colors.text.error};
    `}
`;
exports.StyledLabel = theme_1.styled.label `
  ${theme_1.typography.regular18}
  color: ${({ theme }) => theme.colors.text.primary};
  letter-spacing: 0.01em;
  ${({ styles }) => styles}
`;
exports.StyledLabelBox = theme_1.styled.div `
  display: flex;
  align-items: center;

  span {
    margin-left: 6px;
    margin-top: 1px;
  }
`;
exports.StyledHeader = theme_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
exports.StyledHelperErrorText = theme_1.styled.div `
  padding-top: 5px;
  ${theme_1.typography.regular14}
  line-height: 20px;

  ${({ error }) => error &&
    (0, theme_1.css) `
      color: ${({ theme }) => theme.colors.text.error};
    `}
`;
